/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options-with-strict-mode.tsx';
import { getReroutableURL } from '@atlassian/jira-fetch/src/utils/get-reroutable-url.tsx';

type AccountId = string;

export const getUserPropertiesUrl = (accountId: AccountId, propertyKey: string): string =>
	`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
const getUserPropertiesUrlWithReroute = (accountId: AccountId, propertyKey: string): string => {
	const path = getUserPropertiesUrl(accountId, propertyKey);
	return getReroutableURL(path);
};

export const setUserProperties = async (
	accountId: AccountId,
	propertyKey: string,
	data: string, // oxlint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
	const url = getUserPropertiesUrlWithReroute(accountId, propertyKey);
	return fetch(url, {
		...getDefaultOptions(url),
		method: 'PUT',
		body: data,
	});
};

export const getUserProperty = <T,>(accountId: AccountId, propertyKey: string): Promise<T> => {
	const url = getUserPropertiesUrlWithReroute(accountId, propertyKey);
	return fetch(url, getDefaultOptions(url))
		.then((res) => {
			if (!res) {
				throw new FetchError(0, 'Fetch returned an undefined response');
			}

			if (res.status === 200) {
				return res.json();
			}

			return res.text().then((errResp) => {
				throw new FetchError(res.status, errResp);
			});
		})
		.then((data) => data.value);
};

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const deleteUserProperty = (accountId: AccountId, propertyKey: string): Promise<any> => {
	const url = getUserPropertiesUrlWithReroute(accountId, propertyKey);
	return fetch(url, {
		...getDefaultOptions(url),
		method: 'DELETE',
	});
};
